<template>
  <section
    class="component-a4c86042"
    resmed-component-name="info_25/75_icon-line_graphic_text"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
      'background-color': acf.layout['background-color'],
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row align-items-center">
          <div class="col-md-8 col-xl-7 offset-xl-1 order-2 order-md-1">
            <h1 v-html="acf.headline"></h1>
          </div>
          <div class="col-md-4 order-1 order-md-2">
            <figure>
              <img
                class="img-fluid p-lg-3"
                v-bind:src="acf.illustration"
                alt=""
              />
            </figure>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-a4c86042", // info_25/75_icon-line_graphic_text
  props: ["acf"],
  created() {
    bus.$emit("navigation:reversed", true);
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-a4c86042 {
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
}

.component {
  padding: 3rem 0 5rem 0;

  @media (min-width: 992px) {
    padding: 3rem 0;
  }

  h1 {
    color: rgba($cc-resmed-white, 0.875);
    margin: 0;
    text-align: center;

    @media (min-width: 768px) {
      text-align: left;
    }
  }

  .content * {
    color: $cc-resmed-white;
  }

  .duration {
    @extend %body-small-bold;
    color: $cc-resmed-white;
    margin-left: 1.25rem;
    padding-left: 1.875rem;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4gICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9IiNGRkYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEpIj4gICAgICAgIDxjaXJjbGUgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIi8+ICAgICAgICA8cGF0aCBkPSJNMTAgNHY2bDQgMiIvPiAgICA8L2c+PC9zdmc+);
    background-position: left center;
    background-size: 1.25rem;
    background-repeat: no-repeat;
  }

  figure {
    max-width: 240px;
    margin: 0 auto;

    @media (min-width: 992px) {
      max-width: none;
    }
  }

  .wrapper {
    min-width: 100%;
    position: absolute;
    bottom: 5rem;

    @media (min-width: 768px) {
      top: 43%;
      bottom: auto;
      transform: translateY(-50%);
    }
  }
}
</style>